import React, {Component} from 'react';
import PropTypes from 'prop-types';

export class ComparisonTabs extends Component {
    static get propTypes() {
        return {
            competitor: PropTypes.string,
            onTabClick: PropTypes.func,
        }
    }

    constructor(props) {
        super(props);
        this.state = { current: 'easysend' };

        this.handleTabClick = this.handleTabClick.bind(this);
    }

    handleTabClick(type) {
        const {onTabClick} = this.props;

        this.setState({current: type});
        onTabClick(type);
    }

    render() {
        const {competitor} = this.props;
        const {current} = this.state;

        return (
            <div className="tabs-wrapper">
                <button
                    type="button"
                    className={`tab-item ${current === 'easysend' ? 'active' : ''}`}
                    onClick={() => this.handleTabClick('easysend')}>
                    <span className="name">EasySend</span>
                </button>
                <button
                    type="button"
                    className={`tab-item ${current === 'competitor' ? 'active' : ''}`}
                    onClick={() => this.handleTabClick('competitor')}>
                    <span className="name">{competitor}</span>
                </button>
            </div>
        )
    }
}